<template>
    <div class="teachers">
        <section class="sectionStyle" style="background-color: #fff;padding: 0 0px 120px;">
        <img src="../../assets/imgs/shapes/shape-13.png" class="sz_bg_img" style="left: 0 ; top: 0;" alt="">
        <img src="../../assets/imgs/shapes/shape-14.png" class="sz_bg_img float-bob-y" style="right: 0;bottom: 0;height: 400px;width: 300px;" alt="">
        <div class="GS_JJ_content_box">
          <div class="ck_header">
            <a-row class="GS_JJ_content_box " style="position: relative;" type="flex" justify="space-between">
              
              <a-col :xs="24" :sm="24" :md="24" :lg="24" class="animate__animated animate__fadeInLeftBig wow">
                <p class="modular_title " style="text-align: center;">师资团队</p>
                <p class="modular_title_en" style="text-align: center;">Renowned Teaching Staff</p>
              </a-col>
              <a-col  :xs="24" :sm="24" class="fixed-width-md " :class="[swiperOptionswhite.slidesPerView > 2 ? 'teacherSwiperButton':'']">
                <div class="swiperButton">
                  <div class="swiper-button-prev swiper-button-prev-sz swiper-button-white " slot="button-prev"><a-icon type="left" /></div>
                  <div class="swiper-button-next swiper-button-next-sz swiper-button-white " slot="button-next"><a-icon type="right" /></div>
                </div>
              </a-col>
            </a-row>
          </div>
          <swiper ref="mySwiperKc" :options="swiperOptionswhite" style="height: 515px;" class="swiper-wrappe carousel animate__animated animate__fadeIn wow">
                <swiper-slide class="swiper-slide"  v-for="(b,i) in headerBannerList" :key="i">
                  <div class="sz_list_box">
                    <div class="image_sz">
                      <img style="height: 100%;" :src="b.img" alt="">
                    </div>
                    <div class="content">
                      <div class="author-info">
                        <h5 style="font-size: 22px;margin: 0;">{{ b.oneText }}</h5>
                        <span>{{ b.twoText }}</span>
                      </div>
                      <div class="social-links p-relative">
                        <span class="social"><i class="iconfont">&#xe739;</i></span>
                        <ul>
                            <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                        </ul>
                      </div>
                  </div>
                  </div>
                </swiper-slide>
          </swiper>
        </div>
      </section>
    </div>
</template>
<script>
export default {
    props:[],
    watch:{},
    name: "teachers",
    components: {},
    data() {
        return {
            swiperOptionswhite:{
                autoplay:false,
                speed: 800,
                observer: true,
                observeParents: true,
                slidesPerView: 3, // 大于900像素时显示3个幻灯片
                spaceBetween: 20,  // 可选：设置间距
                //设置点击箭头
                navigation: {
                nextEl: ".swiper-button-next-sz",
                prevEl: ".swiper-button-prev-sz",
                },
                loop: true,
                breakpoints: {
                  920: {  //当屏幕宽度小于等于1280
                    slidesPerView: 2,
                    spaceBetween: 20
                  },
                  768: {  //当屏幕宽度小于等于768
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                } 
            },
            headerBannerList:[],
        };
    },
    created() { 
        this.tenantConfig = this.$store.getters.tenantInfo
        if (this.tenantConfig && this.tenantConfig.banner2) {
          var certImages = this.tenantConfig.banner2.split(",");
          if(this.tenantConfig.bannerLinks2){
            var bannerLinks2 = this.tenantConfig.bannerLinks2.split("\n")
          }else{
            var bannerLinks2 = []
          }
          if(this.tenantConfig.bannerTwoLinks2){
            var bannerTwoLinks2 = this.tenantConfig.bannerTwoLinks2.split("\n")
          }else{
            var bannerTwoLinks2 = []
          }
          for (var i in certImages) {
            var b = {};
            b.img = certImages[i];
            if(bannerLinks2.length>i){
              b.oneText = bannerLinks2[i]
            }
            if(bannerTwoLinks2.length > i){
              b.twoText = bannerTwoLinks2[i]
            }
            this.headerBannerList.push(b);
          }
        }
    },
    mounted() { },
    methods: {},
};
</script>
<style lang='less' scoped>
  .teacherSwiperButton{
    position: absolute;
    right: 0;
    top: 35px;
    z-index: 99;
  }
</style>
